import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatSelect } from '@angular/material/select';

interface Option {
  id: number;
  name: string;
}

@Component({
  selector: 'app-dropdown-search',
  templateUrl: './dropdown-search.component.html',
  styleUrls: ['./dropdown-search.component.scss']
})
export class DropdownSearchComponent implements OnInit {
  @ViewChild('search') searchTextBox: ElementRef;
  @ViewChild('selectList') multiSelectRef: MatSelect;
  @Input() options: Option[] = [];
  @Input() placeHolder: string;
  @Output() selectionChange = new EventEmitter<Option>();

  searchText: string = '';
  filteredOptions: Option[] = [];
  selectedOption: Option;
  selectedValue: Option;

  ngOnInit() {
    this.filteredOptions = this.options;
  }

  filterOptions() {
    this.setSelectedValue();
    const filterValue = this.searchText.toLowerCase();
    this.filteredOptions = this.options.filter(option => option.name.toLowerCase().includes(filterValue));
  }

  onSelectionChange(event: any) {
    if (event.source.selected) {
      this.selectedOption = event.source.value;
    }
    this.setSelectedValue();
    this.selectionChange.emit(this.selectedOption);
  }

  openedChange(e: boolean) {
    if (e) {
      this.searchText = '';
      this.filteredOptions = this.options;
      setTimeout(() => this.searchTextBox.nativeElement.focus());
    }
  }

  clearSearch(event: Event) {
    event.stopPropagation();
    this.searchText = '';
    this.filteredOptions = this.options;
  }

  setSelectedValue() {
    if (this.selectedOption) {
      this.selectedValue = this.selectedOption;
    }
  }
}
